exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tool-button.btn{border:2px solid rgba(0,0,0,0)}.tool-button.btn svg{width:24px;height:24px}.tool-button .isvg{display:flex;align-items:center;justify-content:center;width:28px;height:28px}.tool-button.active{border:2px solid #72ca7e}.tool-button.active .isvg{fill:#72ca7e;stroke:#72ca7e}", ""]);

